import { render, staticRenderFns } from "./TourGrid.vue?vue&type=template&id=3644c4ea&scoped=true&"
import script from "./TourGrid.vue?vue&type=script&lang=js&"
export * from "./TourGrid.vue?vue&type=script&lang=js&"
import style0 from "./TourGrid.vue?vue&type=style&index=0&id=3644c4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3644c4ea",
  null
  
)

export default component.exports